import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';
import { ConstructionMaterialCategory } from '@client/features/material-catalog/models/construction-material-category';
import { MaterialResponsibility } from '@client/features/repair-item/types';
import { toEnum } from '@client/core/data/concerns/parses-from-json/to-enum';

/**
 * Backend model for \App\Repair_Item
 */
export class RepairItem {
  constructor(
    public readonly id: number,
    public readonly projectId: number,
    public readonly categoryId: number,
    public readonly constructionMaterialId: Nullable<string>,
    public readonly order: number,
    public readonly name: string,
    public readonly description: Nullable<string>,
    public readonly quantity: Nullable<number>,
    public readonly unit: Nullable<string>,
    public readonly laborCost: number,
    public readonly laborDescription: Nullable<string>,
    public readonly laborNotes: Nullable<string>,
    public readonly laborTotal: number,
    public readonly materialCost: Nullable<number>,
    public readonly materialDescription: Nullable<string>,
    public readonly materialSku: Nullable<string>,
    public readonly materialUrl: Nullable<string>,
    public readonly materialResponsibility: Nullable<MaterialResponsibility>,
    public readonly materialSupplierName: Nullable<string>,
    public readonly materialNotes: Nullable<string>,
    public readonly materialTotal: number,
    public readonly materialImageUrl: Nullable<string>,
    public readonly materialCategory: Nullable<ConstructionMaterialCategory>,
    public readonly internetNo: Nullable<string>,
    public readonly total: number,
    public readonly isPurchased: boolean,
  ) {}
}

defineTransform(RepairItem, (json, { fromSnakeCaseKeys, nullOr }) => {
  return {
    ...fromSnakeCaseKeys(),
    materialResponsibility: json.material_responsibility
      ? toEnum(MaterialResponsibility, json.material_responsibility)
      : null,
    materialCategory: nullOr(json.material_category, () =>
      ConstructionMaterialCategory.findBySlug(json.material_category),
    ),
  };
});
